var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIllustrationAiVoice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1241,
    height: 755,
    viewBox: "0 0 1241 755",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M257.206 171.17C165.913 162.471 211.169 490.355 2 512.66V755H1241V545.38C1118.9 545.38 1131.27 449.599 1061.86 496.441C975.089 554.994 928.84 631.978 853.687 490.356C752.606 299.872 593.432 641.407 517.416 639.476C372.299 635.788 371.323 182.044 257.206 171.17Z",
    fill: "url(#paint0_linear_943_2141)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M175.14 0C80.063 -0.000441649 88.0695 511.187 2 511.187V755H1241V544.992C1189.96 556.261 1163.94 471.234 1101.89 534.748C944.583 695.765 857.998 645.386 761.613 518.357C528.425 211.031 476.364 544.992 400.322 544.992C222.178 544.992 289.819 0.000532709 175.14 0Z",
    fill: "url(#paint1_linear_943_2141)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M1 450.06C92.0143 456.375 121.019 294.278 156.024 181.652C207.715 15.3439 243.038 102.945 279.044 181.652C320.365 271.979 409.608 649 497.078 649C584.636 649 657.298 325.891 731.17 325.891C772.732 325.891 830.142 561.635 876.137 561.635C929.337 561.635 996.06 378.542 1024.88 380.958C1053.69 383.373 1077.64 471.285 1105.78 443.751C1132.94 417.185 1127.4 421.897 1241 421.897",
    stroke: "url(#paint2_linear_943_2141)",
    strokeWidth: 10
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_943_2141",
    x1: 1957.58,
    y1: -184.601,
    x2: -57.6607,
    y2: 771.127,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4B9",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4B9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_943_2141",
    x1: 1957.58,
    y1: -248.753,
    x2: -104.512,
    y2: 666.692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00C4B9",
    stopOpacity: 0.51
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00C4B9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_943_2141",
    x1: 1524.73,
    y1: -227.173,
    x2: -108.913,
    y2: 864.169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C4C4C4",
    stopOpacity: 0.75
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D9D9D9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationAiVoice);
export default __webpack_public_path__ + "static/media/illustration_AI_Voice.7ccc3f58acc1415799473990a87cdf8c.svg";
export { ForwardRef as ReactComponent };